<template>
  <section>
    <div class="row">
      <div class="content">
        <h4 v-if="step1"><b>Select Plan</b></h4>
        <p v-if="step1">Complete your subscription</p>
        <h4 v-if="step2"><b>One move ahead</b></h4>
        <p v-if="step2">You're almost there can be removed. Complete your subscription</p>
        <div class="col-md-8 p-1" v-if="step1">
          <div class="panel-group">
          <div class="panel panel-default">
            <div class="panel-heading cursor-p" @click="changeAccordion(1)">
              <h4 class="panel-title">
                <a>standard <i v-if="!showone" class="uil uil-angle-down pull-right"></i> <i v-if="showone" class="uil uil-angle-up pull-right"></i></a>
              </h4>
            </div>
            <div id="collapse1" class="panel-collapse" v-if="showone">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <div>
                    <a id="plan1_one" @click="changePlan('standard','plan1_one',1)" v-bind:class="{'active': plan1_one}" class="btn btn-app">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Month</span><br>
                      <span><b>₹ 35,000</b></span>
                    </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan1_two}" @click="changePlan('standard','plan1_two',3)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>3 Month</span><br>
                      <span><b>₹ 105,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan1_three}" @click="changePlan('standard','plan1_three',6)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>6 Month</span><br>
                      <span><b>₹ 210,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan1_four}" @click="changePlan('standard','plan1_four',12)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Year</span><br>
                      <span><b>₹ 420,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-12"><hr></div>
                  <div class="col-xs-4 pull-right">
                    <div class="table-responsive">
                      <table class="table payment">
                        <tbody><tr>
                          <td style="width:50%">Subtotal:</td>
                          <td class="pull-right">{{standard_sub_total | currency('₹') }}</td>
                        </tr>
                        <tr>
                          <td>GST (18%)</td>
                          <td class="pull-right">{{standard_gst | currency('₹')}}</td>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <th class="pull-right">{{standard_total | currency('₹')}}</th>
                        </tr>
                        <tr>
                          <th></th>
                          <td><button @click="addToCart(standard_sub_total, standard_gst, standard_total)" class="btn btn-success pull-right" style="border-radius: 6px !important;">Add</button></td>
                        </tr>
                      </tbody></table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="panel-footer">Panel Footer</div> -->
            </div>
          </div>
        </div>
        <div class="panel-group">
          <div class="panel panel-default">
            <div class="panel-heading cursor-p" @click="changeAccordion(2)">
              <h4 class="panel-title">
                <a>Professional <i v-if="!showtwo" class="uil uil-angle-down pull-right"></i> <i v-if="showtwo" class="uil uil-angle-up pull-right"></i></a>
              </h4>
            </div>
            <div id="collapse2" class="panel-collapse" v-if="showtwo">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan2_one}" @click="changePlan('professional','plan2_one',1)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Month</span><br>
                      <span><b>₹ 50,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan2_two}" @click="changePlan('professional','plan2_two',3)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>3 Month</span><br>
                      <span><b>₹ 150,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan3_three}" @click="changePlan('professional','plan2_three',6)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>6 Month</span><br>
                      <span><b>₹ 300,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan2_four}" @click="changePlan('professional','plan2_four',12)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Year</span><br>
                      <span><b>₹ 600,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-12"><hr></div>
                  <div class="col-xs-4 pull-right">
                    <div class="table-responsive">
                      <table class="table payment">
                        <tbody><tr>
                          <td style="width:50%">Subtotal:</td>
                          <td class="pull-right">{{professional_sub_total | currency('₹') }}</td>
                        </tr>
                        <tr>
                          <td>GST (18%)</td>
                          <td class="pull-right">{{professional_gst | currency('₹')}}</td>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <th class="pull-right">{{professional_total | currency('₹')}}</th>
                        </tr>
                        <tr>
                          <th></th>
                          <td><button @click="addToCart(professional_sub_total, professional_gst, professional_total)" class="btn btn-success pull-right" style="border-radius: 6px !important;">Add</button></td>
                        </tr>
                      </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="panel-footer">Panel Footer</div> -->
            </div>
          </div>
        </div>

        <div class="panel-group">
          <div class="panel panel-default">
            <div class="panel-heading cursor-p" @click="changeAccordion(3)">
              <h4 class="panel-title">
                <a>Premium <i v-if="!showthree" class="uil uil-angle-down pull-right"></i> <i v-if="showthree" class="uil uil-angle-up pull-right"></i></a>
              </h4>
            </div>
            <div id="collapse2" class="panel-collapse" v-if="showthree">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan3_one}" @click="changePlan('premium','plan3_one',1)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Month</span><br>
                      <span><b>₹ 85,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan3_two}" @click="changePlan('premium','plan3_two',3)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>3 Month</span><br>
                      <span><b>₹ 255,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan3_three}" @click="changePlan('premium','plan3_three',6)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>6 Month</span><br>
                      <span><b>₹ 510,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-3">
                    <a class="btn btn-app" v-bind:class="{'active': plan3_four}" @click="changePlan('premium','plan3_four',12)">
                      <!-- <span class="badge bg-green">30%</span> -->
                      <span>1 Year</span><br>
                      <span><b>₹ 1,020,000</b></span>
                    </a>
                  </div>
                  <div class="col-md-12"><hr></div>
                  <div class="col-xs-4 pull-right">
                    <div class="table-responsive">
                      <table class="table payment">
                        <tbody><tr>
                          <td style="width:50%">Subtotal:</td>
                          <td class="pull-right">{{premium_sub_total | currency('₹') }}</td>
                        </tr>
                        <tr>
                          <td>GST (18%)</td>
                          <td class="pull-right">{{premium_gst | currency('₹')}}</td>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <th class="pull-right">{{premium_total | currency('₹')}}</th>
                        </tr>
                        <tr>
                          <th></th>
                          <td><button @click="addToCart(premium_sub_total, premium_gst, premium_total)" class="btn btn-success pull-right" style="border-radius: 6px !important;">Add</button></td>
                        </tr>
                      </tbody></table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-footer">Panel Footer</div>
            </div>
          </div>
        </div>
        </div>
        <div class="col-md-8 p-1" v-if="step2">
          <div class="box">
            <div class="box-header tc">
              <div class="btn-group new-design">
                <button type="button" @click="userTypelogin = true,userTypesignup = false" v-bind:class="{'btn-default': userTypesignup,'btn-success': userTypelogin}" class="btn">Login</button>
                <button type="button" @click="userTypesignup = true,userTypelogin = false" v-bind:class="{'btn-default': userTypelogin,'btn-success': userTypesignup}" class="btn">Signup</button>
              </div>
            </div>
            <div class="box-body" v-if="userTypelogin">
              <b-form class="form-signup" v-on:submit.prevent="onSubmit" novalidate style="padding: 30px 100px 100px 100px;">
                <div class="form-label-group">
                  <div class="form-group has-feedback">
                    <b-form-input
                    type="text" @keyup="clear()"
                    class="form-control"
                    id="user_email"
                    placeholder="Business Email"
                    v-model.lazy.trim="$v.form.user_email.$model"
                    :state="chkState('user_email')"
                    autofocus
                  />
                    <div v-if="$v.form.user_email.$error">
                      <p v-if="!$v.form.user_email.required" class="error-msg">* Enter your email </p>
                      <p v-if="!$v.form.user_email.email" class="error-msg">* Enter the valid email </p>
                    </div>
                    <div v-if="!$v.form.user_email.$error">
                      <p v-if="errormsg == 'Invalid EmailID'" class="error-msg">* Email does not exists</p>
                    </div>
                  </div>
                </div>
                <div class="form-label-group form-forgot-password">
                  <div class="form-group has-feedback">
                    <b-form-input
                      :type="passwordFieldType" @keyup="clear()"
                      class="form-control cleardefault"
                      placeholder="Password"
                      v-model.lazy.trim="$v.form.user_password.$model"
                      :state="chkState('user_password')"
                    />
                    <span class="uil uil-eye form-control-feedback"
                      v-if="passwordFieldType == 'text'"
                      @click="switchVisibility"></span>
                    <span class="uil uil-eye-slash form-control-feedback"
                      v-if="passwordFieldType == 'password'"
                      @click="switchVisibility"></span>
                    <div v-if="$v.form.user_password.$error">
                      <p v-if="!$v.form.user_password.required" class="error-msg">* Enter the password</p>
                      <!-- <p v-if="!$v.form.user_email.email" class="error-msg">* Please enter the valid Email ID</p> -->
                    </div>
                    <div v-if="!$v.form.user_password.$error">
                      <p v-if="errormsg == 'Invalid Password'" class="error-msg">* Incorrect password</p>
                    </div>
                  </div>
                </div>
                <div class="control">
                  <!-- <span
                    class="form-forgot-password-content form-join-now cursor-usage pull-right"
                    @click="forgetPasswordRedirect()"
                  >Forgot password?</span> -->
                </div>

                <button style="font-size: 16px;"
                  class="btn btn__large_coman_hight btn-lg btn-success btn-block"
                  type="submit"
                >Checkout</button>
              </b-form>
            </div>
            <div class="box-body" v-if="userTypesignup">
              <b-form class="form-signup" style="padding: 30px 100px 100px 100px;" v-on:submit.prevent="onSubmit1" novalidate>
                <div class="form-label-group">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Email"
                    v-model.lazy.trim="$v.form1.user_email.$model"
                    :state="chkState1('user_email')"
                    @keyup="changeEmail"
                    autofocus
                  />
                  <div v-if="$v.form1.user_email.$error">
                    <p v-if="!$v.form1.user_email.required" class="login-alert-msg error-content">* Enter your email</p>
                    <p v-if="!$v.form1.user_email.email" class="login-alert-msg error-content">* Enter a valid email</p>
                  </div>
                  <div v-if="!$v.form1.user_email.$error">
                    <p v-if="emailvalidate == 1" class="login-alert-msg error-content">* Enter your organization email</p>
                  </div>
                  <div v-if="errormsg == 'Email already exists'">
                    <p class="login-alert-msg error-content">* Email already exists</p>
                  </div>
                </div>
                <div class="form-label-group">
                  <vue-tel-input
                    class="form-control"
                    placeholder="Mobile Number"
                    @onInput="onInput"
                    v-bind:class="{ 'is-invalid': !isValiedmobileNumber }"
                    :state="chkState1('mobile_number')"
                  ></vue-tel-input>
                  <div v-if="$v.form1.mobile_number.$error">
                    <p v-if="!$v.form1.mobile_number.required" class="login-alert-msg error-content">* Enter your mobile number</p>
                    <p v-if="!$v.form1.mobile_number.minLength" class="login-alert-msg error-content">* Enter a valid mobile number</p>
                  </div>
                  <div v-if="!$v.form1.user_email.$error">
                    <p v-if="errormsg == 'Email not exit!'" class="login-alert-msg error-content">* Mobile no already exists</p>
                  </div>
                </div>
                <button style="font-size: 16px;"
                  class="btn btn__large_coman_hight btn-lg btn-success btn-block"
                  type="submit"
                >Checkout</button>
              </b-form>
            </div>
          </div>
        </div>
        <div class="col-md-4">
            <!-- DIRECT CHAT -->
            <div class="box box-warning direct-chat direct-chat-warning">
              <div class="box-header with-border">
                <h3 class="box-title"><b>Order Summary</b></h3>
              </div>
              <!-- /.box-header -->
              <div class="box-body">
                <div class="col-xs-12 pull-right">
                  <div class="table-responsive">
                    <table class="table payment">
                        <tbody>
                        <tr v-if="step2">
                          <td style="width:50%">Plan</td>
                          <th class="pull-right">{{type}}</th>
                        </tr>
                        <tr v-if="step2" style="border-bottom: 1px solid #cccccc54;">
                          <td>Plan Duration</td>
                          <td class="pull-right" v-if="month == 1">1 month</td>
                          <td class="pull-right" v-if="month != 1">{{month}} months</td>
                        </tr>
                        <tr>
                          <td style="width:50%">Subtotal:</td>
                          <td class="pull-right">{{sub_total | currency('₹') }}</td>
                        </tr>
                        <tr>
                          <td>GST (18%)</td>
                          <td class="pull-right">{{gst | currency('₹')}}</td>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <th class="pull-right">{{total | currency('₹')}}</th>
                        </tr>
                        <tr>
                          <td colspan="2"><button v-if="step1" @click="verify()" class="btn btn-success pull-right" style="border-radius: 6px !important;width:100%;">Make Payment</button></td>
                        </tr>
                        <tr>
                          <td colspan="2" class="tc">
                            <p class="tc mb-1" style="font-size: 12px;">By checking out you agree with our Privacy Policy. This site is protected by reCAPTCHA and the Google <a target="_blank" href="https://www.screenit.io/privacy_policy.html">Privacy Policy and Terms of Service </a> apply. </p>
                            Powered By <img style="width: 40%;" src="../../assets/img/Razorpay.png">
                          </td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              </div>
              <!-- /.box-footer-->
            </div>
            <!--/.direct-chat -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@tiltbike/razorpay-checkout-js/dist/checkout.js'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'// import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import axios from 'axios'
import router from '../../router/index'
import Vue2Filters from 'vue2-filters'
import { VueTelInput } from 'vue-tel-input'
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(VueCryptojs)
Vue.use(Vue2Filters)
// import $ from 'jquery'
const optionsOverrides = {
  durations: {
    global: 3000
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
const formShape = {
  user_email: '',
  user_password: '',
  type_of_account: ''
}
const formShape1 = {
  user_email: '',
  mobile_number: '',
  organizationStatus: ''
}
export default {
  name: 'userprofile',
  data () {
    return {
      form: Object.assign({}, formShape),
      form1: Object.assign({}, formShape1),
      userInfo: [],
      passwordFieldType: 'password',
      errormsg: '',
      forceActive1: false,
      forceActive2: false,
      forceActive3: false,
      element: null,
      type: '',
      month: 1,
      plan1_one: '',
      plan1_two: false,
      plan1_three: false,
      plan1_four: false,
      plan2_one: false,
      plan2_two: false,
      plan2_three: false,
      plan2_four: false,
      plan3_one: false,
      plan3_two: false,
      plan3_three: false,
      plan3_four: false,
      showone: false,
      showtwo: false,
      showthree: false,
      standard_sub_total: 0,
      standard_gst: 0,
      standard_total: 0,
      professional_sub_total: 0,
      professional_gst: 0,
      professional_total: 0,
      premium_sub_total: 0,
      premium_gst: 0,
      premium_total: 0,
      sub_total: 0,
      gst: 0,
      total: 0,
      order_id: '',
      step1: true,
      step2: false,
      step3: false,
      userTypesignup: false,
      userTypelogin: true,
      isValiedmobileNumber: true,
      razorpay_keyID: '',
      razorpay_keySecret: ''
    }
  },
  components: {
    VueTelInput
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      user_email: {
        required,
        email
        // minLength: minLength(2)
      },
      user_password: {
        required
      },
      type_of_account: {

      }
    },
    form1: {
      user_email: {
        required,
        email
      },
      mobile_number: {
        required,
        // maxLength: maxLength(12),
        minLength: minLength(10)
      },
      organizationStatus: {}
    }
  },
  created () {
    this.type = this.$route.params.id
    console.log(this.userInfo)
    // console.log(this.type)
    // const encryptedText = this.CryptoJS.AES.encrypt('Professional', 'Secret Passphrase').toString()
    // console.log(encryptedText)
    const decryptedText = this.CryptoJS.AES.decrypt(this.type, 'Secret Passphrase').toString(this.CryptoJS.enc.Utf8)
    console.log(decryptedText)
    this.type = decryptedText
    if (this.type === 'Standard') {
      this.forceActive1 = true
      this.plan1_one = true
      this.showone = true
      this.changePlan('standard', 'plan1_one', 1)
      this.addToCart(this.standard_sub_total, this.standard_gst, this.standard_total)
    } else if (this.type === 'Professional') {
      this.forceActive2 = true
      this.plan2_one = true
      this.showtwo = true
      this.changePlan('professional', 'plan2_one', 1)
      this.addToCart(this.professional_sub_total, this.professional_gst, this.professional_total)
    } else {
      this.forceActive3 = true
      this.plan3_one = true
      this.showthree = true
      this.changePlan('premium', 'plan3_one', 1)
      this.addToCart(this.premium_sub_total, this.premium_gst, this.premium_total)
    }
    // U2FsdGVkX1/r4ZSNI7tocdhWsR2tDFznfGgv9HmhmGw= Standard
    // U2FsdGVkX18uDPvLo6FWuzRlGoArMWNOcGINEXt5UxY= Professional
    // U2FsdGVkX182O3DmHkZeVXTbTEKan0AwR1aDv7kKBqo= Premium
  },
  methods: {
    addToCart (sub, gst, total) {
      this.sub_total = sub
      this.gst = gst
      this.total = total
      this.$awn.success('Add to cart Successfully', optionsOverrides)
    },
    verify () {
      console.log(this.total)
      if (this.total === '' || this.total === null || this.total === 0) {
        this.$awn.alert('Please add to cart your selected plan', optionsOverrides1)
        return false
      }
      this.step1 = false
      this.step2 = true
      const data = {
        amount: this.total + '00',
        currency: 'INR',
        receipt: 'screenit'
      }
      axios.post(BaseURL + '/razorpay/getorderid', data).then(response => {
        this.order_id = response.data.razorpay.order_id.id
        console.log(this.order_id)
        this.razorpay_keyID = response.data.razorpay.key_id
        this.razorpay_keySecret = response.data.razorpay.key_secret
      }).catch(e => {
        console.log(e)
      })
    },
    makePayment () {
      console.log(this.total)
      localStorage.setItem('order_id', this.order_id)
      localStorage.setItem('sub_total', this.sub_total)
      localStorage.setItem('gst', this.gst)
      localStorage.setItem('total', this.total)
      localStorage.setItem('type', this.type)
      localStorage.setItem('month', this.month)
      const options = {
        key: this.razorpay_keyID,
        // description: 'Testing payment from screenit',
        order_id: this.order_id,
        handler: function (response) {
          console.log(response)
          // console.log(response.razorpay_order_id)
          console.log(response.razorpay_payment_id)
          // console.log(response.razorpay_signature)
          // if (this.userTypesignup) {
          //   this.sendEmail(response.razorpay_payment_id)
          // } else {
          console.log('done')
          // this.storedPaymentDetails(response.razorpay_payment_id)
          console.log(this.userInfo)
          this.userInfo = JSON.parse(localStorage.getItem('user__details'))
          const data = {
            orderId: localStorage.getItem('order_id'),
            actualAmount: localStorage.getItem('sub_total'),
            gstAmount: localStorage.getItem('gst'),
            totalAmount: localStorage.getItem('total'),
            packageType: localStorage.getItem('type'),
            packageMonth: localStorage.getItem('month'),
            orgId: this.userInfo._id,
            paymentId: response.razorpay_payment_id
          }
          console.log(data)
          axios.post(BaseURL + '/payment', data).then(response => {
            console.log('success')
            router.push({ name: 'PackageMessage', params: { type: 'success' } })
            // router.push({ name: 'MeetingEnd', params: { id: this.sid, type: this.type } })
            // router.push({ name: 'packageMessage', query: { type: 'success' } })
          }).catch(e => {
            console.log(e)
          })
          // }
        }
      }
      const rzp = new window.Razorpay(options)
      rzp.on('payment.failed', function (response) {
        // alert(response.error.code)
        // alert(response.error.description)
        // alert(response.error.source)
        // alert(response.error.step)
        // alert(response.error.reason)
        // alert(response.error.metadata.order_id)
        // alert(response.error.metadata.payment_id)
        this.userInfo = JSON.parse(localStorage.getItem('user__details'))
        const data = {
          orderId: response.error.metadata.order_id,
          actualAmount: localStorage.getItem('sub_total'),
          gstAmount: localStorage.getItem('gst'),
          totalAmount: localStorage.getItem('total'),
          packageType: localStorage.getItem('type'),
          packageMonth: localStorage.getItem('month'),
          orgId: this.userInfo._id,
          paymentId: response.error.metadata.payment_id
        }
        console.log(data)
        axios.post(BaseURL + '/payment', data).then(response => {
          console.log('success')
          router.push({ name: 'PackageMessage1', params: { type: 'failed' } })
          // router.push({ name: 'MeetingEnd', params: { id: this.sid, type: this.type } })
          // router.push({ name: 'packageMessage', query: { type: 'success' } })
        }).catch(e => {
          console.log(e)
        })
      })
      rzp.open()
    },
    storedPaymentDetails (payment) {
      console.log(this.userInfo)
    },
    onHeadingClick (val) {
      // console.log(val)
      const active = val.item.$el.dataset.vsaActive
      // console.log(this.element)
      const title = val.item.$attrs.title
      console.log(title)
      this.type = title
      if (title === 'standard' && active) {
        this.forceActive1 = true
      } else {
        this.forceActive1 = false
      }
      if (title === 'professional' && active) {
        this.forceActive2 = true
      } else {
        this.forceActive2 = false
      }
      if (title === 'premium' && active) {
        this.forceActive3 = true
      } else {
        this.forceActive3 = false
      }
    },
    changeAccordion (id) {
      this.showone = false
      this.showtwo = false
      this.showthree = false
      if (id === 1) {
        if (this.showone) {
          this.showone = false
        } else {
          this.showone = true
        }
      }
      if (id === 2) {
        if (this.showtwo) {
          this.showtwo = false
        } else {
          this.showtwo = true
        }
      }
      if (id === 3) {
        if (this.showthree) {
          this.showthree = false
        } else {
          this.showthree = true
        }
      }
    },
    changePlan (type, plan, month) {
      this.plan1_one = ''
      this.plan1_two = false
      this.plan1_three = false
      this.plan1_four = false
      this.plan2_one = false
      this.plan2_two = false
      this.plan2_three = false
      this.plan2_four = false
      this.plan3_one = false
      this.plan3_two = false
      this.plan3_three = false
      this.plan3_four = false
      console.log(plan)
      console.log(type)
      this.total = 0
      this.gst = 0
      this.sub_total = 0
      this.standard_sub_total = 0
      this.standard_gst = 0
      this.standard_total = 0
      this.professional_sub_total = 0
      this.professional_gst = 0
      this.professional_total = 0
      this.premium_sub_total = 0
      this.premium_gst = 0
      this.premium_total = 0
      if (type === 'standard') {
        console.log(plan)
        if (plan === 'plan1_two') {
          console.log(plan)
          this.plan1_two = true
          console.log(this.plan1_two)
          this.month = 2
        }
        if (plan === 'plan1_three') {
          this.plan1_three = true
          this.month = 3
        }
        if (plan === 'plan1_four') {
          this.plan1_four = true
          this.month = 4
        }
        if (plan === 'plan1_one') {
          this.plan1_one = 'active'
          console.log(this.plan1_one)
          this.month = 1
        }
        console.log(month)
        this.standard_sub_total = 35000 * parseInt(month)
        this.standard_gst = parseFloat(this.standard_sub_total).toFixed(2) * 18 / 100
        this.standard_total = parseInt(parseFloat(this.standard_sub_total).toFixed(2)) + parseInt(Math.round(parseFloat(this.standard_gst).toFixed(2)))
        console.log(this.standard_total)
      }
      if (type === 'professional') {
        if (plan === 'plan2_two') {
          this.plan2_two = true
          this.month = 2
        }
        if (plan === 'plan2_three') {
          this.plan2_three = true
          this.month = 3
        }
        if (plan === 'plan2_four') {
          this.plan2_four = true
          this.month = 4
        }
        if (plan === 'plan2_one') {
          this.plan2_one = true
          this.month = 1
        }
        this.professional_sub_total = 50000 * parseInt(month)
        this.professional_gst = parseFloat(this.professional_sub_total).toFixed(2) * 18 / 100
        this.professional_total = parseInt(parseFloat(this.professional_sub_total).toFixed(2)) + parseInt(Math.round(parseFloat(this.professional_gst).toFixed(2)))
      }
      if (type === 'premium') {
        if (plan === 'plan3_two') {
          this.plan3_two = true
          this.month = 2
        }
        if (plan === 'plan3_three') {
          this.plan3_three = true
          this.month = 3
        }
        if (plan === 'plan3_four') {
          this.plan3_four = true
          this.month = 4
        }
        if (plan === 'plan3_one') {
          this.plan3_one = true
          this.month = 1
        }
        this.premium_sub_total = 85000 * parseInt(month)
        this.premium_gst = parseFloat(this.premium_sub_total).toFixed(2) * 18 / 100
        this.premium_total = parseInt(parseFloat(this.premium_sub_total).toFixed(2)) + parseInt(Math.round(parseFloat(this.premium_gst).toFixed(2)))
      }
    },
    clear () {
      this.errormsg = ''
    },
    onSubmit () {
      this.form.type_of_account = 'organization'
      if (this.validate()) {
        this.$nextTick(() => {
          const data = {
            user_email: this.form.user_email.toLowerCase(),
            user_password: this.form.user_password,
            type_of_account: this.form.type_of_account,
            device_token: JSON.parse(localStorage.getItem('push_token'))
          }
          axios
            .post(BaseURL + '/login', {
              formData: data
            }).then(response => {
              this.errormsg = response.data.message
              localStorage.clear()
              if (response.data.message === 'Invalid Password' || response.data.message === 'Invalid EmailID') {
                this.userStatus = true
              } else {
                this.userStatus = false
                console.log(this.userInfo)
                localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
                localStorage.setItem('token', JSON.stringify(response.data.token))
                localStorage.setItem('logtype', 'login')
                this.makePayment()
              }
            }).catch(e => {
              console.log(e)
            })
        })
      } else {
        console.log('else................')
      }
    },
    forgetPasswordRedirect () {
      router.push({ name: 'forgetPassword' })
    },
    OnGoogleAuthFail (error) {
      console.log(error)
    },
    switchVisibility () {
      this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    userRegister () {
      router.push({ name: 'Registration' })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState1 (val) {
      const field = this.$v.form1[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some(child => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    // signup
    changeEmail () {
      console.log(this.form1.user_email)
      const email = this.form1.user_email
      const str = email.split('@')
      this.emailvalidate = 0
      console.log(str)
      if (str[1] === 'gmail.com' || str[1] === 'Gmail.com' || str[1] === 'yahoo.com' || str[1] === 'Yahoo.com') {
        this.emailvalidate = 1
      } else {
        this.emailvalidate = 0
      }
    },
    clearmsg () {
      this.errormsg = ''
    },
    onInput ({ number, isValid, country }) {
      console.log(this.form)
      console.log(isValid)
      console.log(country)
      this.isValiedmobileNumber = isValid
      this.form1.mobile_number_country_code = country.dialCode
      this.form1.mobile_number = number.significant
    },
    onSubmit1 () {
      console.log(this.isValiedmobileNumber)
      this.form.user_password = this.form1.mobile_number
      this.form.user_email = this.form1.user_email
      console.log(this.form1)
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.emailvalidate === 1) {
            return false
          }
          if (this.isValiedmobileNumber) {
            const data = {
              user_email: this.form1.user_email.toLowerCase(),
              mobile_number: this.form1.mobile_number,
              organizationStatus: this.form1.organizationStatus,
              mobile_number_country_code: this.form1.mobile_number_country_code
            }
            axios
              .post(BaseURL + '/email/create/user/using/email', {
                formData: data
              })
              .then(response => {
                // this.storedPaymentDetails(order, pay, sign)
                this.errormsg = response.data.message
                if (response.data.userDetails.user_email === data.user_email) {
                  localStorage.setPassword = true
                } else {
                  this.currentModel = this.form.user_email
                  this.userStatus = true
                }
                localStorage.setItem('user__details', JSON.stringify(response.data.userDetails))
                localStorage.setItem('token', JSON.stringify(response.data.token))
                localStorage.setItem('logtype', 'signup')
                this.makePayment()
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            this.isValiedmobileNumber = false
          }
        })
      } else {
        this.isValiedmobileNumber = false
        console.log('else................')
      }
    },
    sendEmail (order, pay, sign) {
      const data = {
        user_email: this.form1.user_email.toLowerCase(),
        mobile_number: this.form1.mobile_number,
        organizationStatus: this.form1.organizationStatus,
        mobile_number_country_code: this.form1.mobile_number_country_code
      }
      axios
        .post(BaseURL + '/email/create/user/using/email', {
          formData: data
        })
        .then(response => {
          this.storedPaymentDetails(order, pay, sign)
          this.errormsg = response.data.message
          this.userInfo = JSON.parse(response.data.userDetails)
          localStorage.setItem('logtype', 'signup')
          if (response.data.userDetails.user_email === data.user_email) {
            localStorage.setPassword = true
          } else {
            this.currentModel = this.form.user_email
            this.userStatus = true
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: 3px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
label {
  font-size: 12px;
  font-weight: inherit;
  color: #5b5b5b87;
}
.form-control {
    height: 40px;
    color: #3D3D3D !important;
    border: 1px solid #ccc !important;
}
.cdc-legend-item-color {
    height: 0.35em !important;
    width: 1.15em !important;
    border-radius: 2px;
    margin-right: .5em;
}
.over-len {
    display: block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.select-icon i {
  margin-top: 14px;
}
.is-invalid {
    border-color: #f86c6b !important;
}
.is-valid {
  /* border-color: #5bad2b !important; */
  border: 1px solid #ccc !important;
}
.toast-success {
    background-color: #5BAD2B !important;
}
.profile-user-img {
    margin: 0 auto;
    width: 100px;
    padding: 3px;
    border: 3px solid #d2d6de;
    height: 100px;
}
.vicp-img {
  left: -18.146px !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 36%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 13px;
}
.table.payment>tbody>tr>td, .table.payment>tfoot>tr>td {
  border-top: 0px solid #f4f4f4 !important;
}
.panel-default>.panel-heading {
    color: #333;
    background-color: #ffffff !important;
}
.new-design .btn-success {
  width: 100px !important;
  border-radius: 5px !important;
}
.new-design .btn {
  width: 100px !important;
}
</style>
